import React from 'react'
import { Link } from 'react-router-dom'
import WhatWeDoImg from '../../assets/images/what-we-do-img.png'

const WhatWeDo = () => (
  <div className="bodySec whatWeDoSec">
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-5">
          <div className="shadowImg">
            <img src={WhatWeDoImg} alt="" />
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-7">
          <div className="whatWeDoTxt">
            <h2>
              <span>What We Do</span>
            </h2>
            <h4>
              <span>Deep Learning Predictions for Real Markets</span>
            </h4>
            <p>
              DeepTrading.ai uses deep neural networks to estimate future price levels across multiple horizons, from
              tomorrow to next year. You get predicted prices (and implied returns) in a simple, consistent format so
              you can plan, compare, and track performance over time.
            </p>
            <p><Link className="btn btn-primary" to="/pricing-plans">Compare Plans</Link></p>
            <h3>What you get</h3>
            <ul>
              <li>Multi-horizon predictions (1D, 2D, 1W, 2W, 1M, 2M, 3M, 6M, 1Y)</li>
              <li>Historical track record and accuracy metrics, including “hybrid accuracy” (direction + closeness)</li>
              <li>Top 50 predicted movers and a searchable history of past predictions</li>
              <li>Trading Strategies and historical backtesting to explore simple Buy/Sell/Hold rules</li>
            </ul>
            <h3>Subscription-Based Service</h3>
            <p>
              DeepTrading.ai offers two subscription plans (plus a one-week pass). A flat fee, charged monthly or
              yearly, provides access to our models for a focused universe of 250 stocks.
            </p>
            <ul>
              <li>
                Basic includes short-horizon predictions: daily, two-day, and weekly.
              </li>
              <li>
                Advanced unlocks the full horizon set through yearly predictions.
              </li>
            </ul>
            <p>
              In addition, our Deep Index (our next-day prediction for the Dow, DJI) is available on our homepage free
              of charge so anyone can preview how the model behaves.
            </p>
            <p>
              Whether you’re just getting started or you already live in charts, the product stays simple: pick a
              ticker, pick a horizon, and see the predicted price, implied return, and track record.
            </p>
            <p>
              <Link to="/contact-us">Reach out today</Link>&nbsp;
              to learn more about the platform or ask questions about your use case.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WhatWeDo;
